const OssStyler = {
    getThumbnailResUrl(url) {
        return url + "?x-oss-process=style/thumbnail";
    },
    getLowResUrl(url) {
        return url + "?x-oss-process=style/low";
    },
    getMediumResUrl(url) {
        return url + "?x-oss-process=style/medium";
    },
    getHighResUrl(url) {
        return url + "?x-oss-process=style/high";
    },
    getOriginalResUrl() {
        return url + "?x-oss-process=style/original";
    },
    getOssStyle() {
        if (screen.height >= 1024) {
            return '?x-oss-process=style/original';
        }
        else if (screen.height >= 768) {
            return '?x-oss-process=style/high';
        }
        else if (screen.height >= 512) {
            return '?x-oss-process=style/medium';
        }
        return '?x-oss-process=style/low';
    }
};

export default OssStyler